/* eslint-disable no-use-before-define */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import Loader from 'react-loader-spinner';
import ModalPopupScreen from '../../ModalScreen/ModalPopupScreen';
import { auth_token, authority_msg, put_about_us_url } from '../../WebController/WebController';

const DashInsertAboutUs = ({ state, handleLoad, about_id }) => {
    const [loading, setLoading] = useState(false);
    const [stateId, setStateId] = useState(0);
    const [name, setName] = useState("");
    const [title, setTitle] = useState("");
    const [details, setDetails] = useState("");
    const [image, setImage] = useState("");
    const [authToken, setAuthToken] = useState("");


    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    useEffect(() => {
        const auth_token_value = sessionStorage.getItem('auth_token');
        setAuthToken(auth_token_value);
        if (state === "Update") {
            setStateId(3);
            fetchAboutUsData(auth_token_value);
        } else {
            setStateId(1);
        }
    }, []);

    const fetchAboutUsData = async (auth_token_value) => {
        const formData = new FormData();
        formData.append("state", "5");
        formData.append(auth_token, auth_token_value);
        formData.append("id", about_id);

        await fetch(put_about_us_url, {
            method: "POST",
            body: formData,
        })
            .then((res) => res.json())
            .then((data) => {
                if (!data.error) {
                    setName(data.data.name);
                    setTitle(data.data.title);
                    setDetails(data.data.details);
                }

            })
            .catch((error) => {
                console.log(authority_msg);
            });
    };
    const handleSelectedImage = (event) => {
        const imageFile = event.target.files[0];
        setImage(imageFile);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        openModal();
    };
    const popupCloseSubmit = () => {
        setIsModalOpen(false);
        setLoading(true);
        const formData = new FormData();
        formData.append(auth_token, authToken);
        formData.append("state", stateId);
        formData.append("title", title);
        formData.append("name", name);
        formData.append("details", details);
        formData.append("id", about_id);
        formData.append("image", image);

        fetch(put_about_us_url, {
            method: "POST",
            body: formData,
        })
            .then((res) => res.json())
            .then((data) => {
                handleLoad();
                setLoading(false);
            })
            .catch((error) => {
                console.log(authority_msg);
            });
    };
    return (
        <div className="insert-main-div">
            {!loading ? (
                <div className="form-div">
                    <div>
                        <p className="text-center insert-text">{state} About Us</p>
                    </div>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group>
                            <Form.Label className="label-text">Title</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter Title"
                                value={title}
                                onChange={(e) => {
                                    setTitle(e.target.value);
                                }}
                            />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label className="label-text">Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter Name"
                                value={name}
                                onChange={(e) => {
                                    setName(e.target.value);
                                }}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label className="label-text">Details</Form.Label>
                            <Form.Control
                                type="text"
                                as="textarea"
                                rows={4}
                                placeholder="Enter Details (use semicolon for show one after to another)
                                 Ex: text_1 ; 
                                 text_2 ;
                                  text_3 ; "
                                value={details}

                                onChange={(e) => {
                                    setDetails(e.target.value);
                                }}
                            />
                        </Form.Group>
                        {
                            state !== "Update" && (<Form.Group>
                                <Form.Label className='label-text'>Image</Form.Label>
                                <Form.Control
                                    type="file"
                                    placeholder="Select Image"
                                    onChange={handleSelectedImage}
                                    accept="image/*"
                                />
                            </Form.Group>)
                        }

                        <Button
                            variant="primary"
                            type="submit"
                            className="w-100 mt-3 bg-success"
                        >
                            Submit
                        </Button>
                        <ModalPopupScreen
                            isOpen={isModalOpen}
                            onClose={closeModal}
                            title={state}
                            msg={"Are you sure, you want to " + state + " the data?"}
                            popupCloseSubmit={popupCloseSubmit} />
                    </Form>
                </div>
            ) : (
                <div className="row justify-content-center align-items-center loader-div">
                    <Loader type="Puff" color="green" height={100} width={100} />
                </div>
            )}
        </div>
    );
};

export default DashInsertAboutUs;